<template>
  <div class="bg" style="background: url(static/img/background.jpg)">
    <v-container grid-list-lg class="mb-5 responsive-container">
      <v-layout row justify-center wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 md6 lg4>
          <img src="static/logo/logo.svg" width="60%" class="mx-auto mt-2" />
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">Dados Pessoais</h1>
        </v-flex>
        <v-flex xs12 class="mb-4">
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Nome *</p>
                    <v-text-field
                      ref="nome"
                      solo
                      hide-details
                      v-model="form.nome"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Telefone *</p>
                    <v-text-field
                      type="tel"
                      inputmode="tel"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      v-model="form.telefone"
                      placeholder="(00) 00000-0000"
                      solo
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">E-mail *</p>
                    <v-text-field
                      type="email"
                      solo
                      hide-details
                      v-model="form.email"
                      :error="emailError"
                      :error-messages="emailError ? ['E-mail inválido'] : []"
                      @blur="validateEmail"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Empresa (Razão Social) *</p>
                    <v-text-field solo hide-details v-model="form.empresa" />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Cargo *</p>
                    <v-text-field solo hide-details v-model="form.cargo" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">
            Formulário de Subestação
          </h1>
        </v-flex>
        <v-flex xs12 class="d-none">
          <v-card class="card-custom mb-2">
            <v-card-text class="card-custom-text">
              <v-container fluid>
                <v-layout row wrap align-end>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Custo da Energia (R$/MWh) *</p>
                    <v-text-field
                      v-model="form.custo"
                      v-money="money"
                      solo
                      inputmode="decimal"
                      placeholder="Ex.: 450,00"
                      persistent-hint
                    />
                    <p class="mb-0">(Energia + Encargos + Impostos)</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          v-for="(item, index) in subestacoes"
          :key="index"
          class="mb-4"
        >
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 class="pt-2">
                    <div class="simulator-card-title">
                      <p
                        class="primary--text text-uppercase font-weight-bold mb-0"
                      >
                        Subestação {{ index + 1 }}
                      </p>
                      <v-tooltip top v-if="index !== 0">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="ml-auto mr-0"
                            v-on="on"
                            @click="removeCard(index)"
                          >
                            <v-icon>mdi mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Distribuidora de Energia *</p>
                    <v-autocomplete
                      v-model="item.distribuidora_energia"
                      :items="distribuidoras"
                      solo
                      hide-details
                      placeholder="Ex.: Equatorial"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Classe de Tensão Atual *</p>
                    <v-select
                      v-model="item.classe_tensao_atual"
                      :items="classesTensao"
                      solo
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Modalidade *</p>
                    <v-select
                      v-model="item.modalidade"
                      :items="modalidades"
                      solo
                      hide-details
                    />
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Há desconto na Tarifa? *</p>
                    <v-select
                      v-model="item.desconto_tarifa"
                      :items="opcoesDesconto"
                      solo
                      hide-details
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>

                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Demanda Fora Ponta (kW) *</p>
                    <v-text-field
                      v-model="item.demanda_fora_ponta_kw"
                      solo
                      v-money="money"
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 850"
                      append-icon="mdi mdi-flash"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left" v-if="item.modalidade === 'Azul'">
                    <p class="caption mb-2">Demanda Ponta (kW) *</p>
                    <v-text-field
                      v-model="item.demanda_ponta_kw"
                      solo
                      v-money="money"
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 620"
                      append-icon="mdi mdi-flash"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>

                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Consumo Fora Ponta (MWh/mês) *</p>
                    <v-text-field
                      v-model="item.consumo_fora_ponta_mwh_mes"
                      solo
                      v-money="money"
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 120,50"
                      append-icon="mdi mdi-flash"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Consumo Ponta (MWh/mês) *</p>
                    <v-text-field
                      v-model="item.consumo_ponta_mwh_mes"
                      solo
                      v-money="money"
                      hide-details
                      inputmode="decimal"
                      placeholder="Ex.: 18,20"
                      append-icon="mdi mdi-flash"
                    />
                  </v-flex>

                  
                  <v-flex
                    xs12
                    sm12
                    md4
                    class="text-xs-right align-self-end d-none"
                  >
                    <div class="hidden-sm-and-down" style="height: 32px"></div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          class="ml-auto mr-1"
                          v-on="on"
                          @click="addCard"
                        >
                          <v-icon>mdi mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 class="text-xs-right pb-5">
          <v-btn color="primary" @click="sendForm()">
            Enviar dados
            <v-icon right>mdi mdi-send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}

import { VMoney } from "v-money";
import Swal from "sweetalert2";
import BackSimulator from "@/page/widget/backSimulator.vue";
import { mask } from "vue-the-mask";
const createSubestacao = () => ({
  distribuidora_energia: "",
  classe_tensao_atual: "",
  modalidade: "",
  desconto_tarifa: "",
  consumo_fora_ponta_mwh_mes: "",
  consumo_ponta_mwh_mes: "",
  demanda_fora_ponta_kw: "",
  demanda_ponta_kw: "",
});

export default {
  extends: _base,
  directives: {
    money: VMoney,
    mask,
  },
  components: {
    BackSimulator,
  },
  data() {
    return {
      endpoint: global.config.endpoint,
      form: {
        nome: "",
        telefone: "",
        email: "",
        empresa: "",
        cargo: "",
        custo: 0,
      },
      // money: {
      //   decimal: ",",
      //   thousands: ".",
      //   prefix: "",
      //   precision: 2,
      //   masked: false,
      // },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 0,
        masked: false,
      },
      emailError: false,
      classesTensao: ["A4", "A3", "A2"],
      modalidades: ["Azul", "Verde"],
      opcoesDesconto: ["0%", "50%", "100%"],
      subestacoes: [createSubestacao()],
      payloadPreview: null,
      distribuidoras: [
        "AmE",
        "CASTRO-Dis",
        "CEDRAP",
        "CEDRI",
        "CEEE",
        "CEGERO",
        "CEJAMA",
        "CELESC",
        "CELETRO",
        "CELPE",
        "CEMIG",
        "CEMIRIM",
        "CEPRAG",
        "CERAÇÁ",
        "CERAL ANITÁPOLIS",
        "CERAL Araruama",
        "CERAL DIS",
        "CERBRANORTE",
        "CERCI",
        "CERCOS",
        "CEREJ",
        "CERES",
        "CERFOX",
        "CERGAL",
        "CERGAPA",
        "CERGRAL",
        "CERILUZ",
        "CERIM",
        "CERIPA",
        "CERIS",
        "CERMC",
        "CERMISSÕES",
        "CERMOFUL",
        "CERNHE",
        "CERPALO",
        "CERPRO",
        "CERRP",
        "CERSAD",
        "CERSUL",
        "CERTAJA",
        "CERTEL",
        "CERTHIL",
        "CERTREL",
        "CERVAM",
        "CETRIL",
        "CHESP",
        "COCEL",
        "CODESAM",
        "COELBA",
        "COOPERA",
        "COOPERALIANCA",
        "COOPERCOCAL",
        "COOPERLUZ",
        "COOPERMILA",
        "COOPERNORTE",
        "COOPERSUL",
        "COOPERZEM",
        "COORSEL",
        "COPEL",
        "COPREL",
        "COSERN",
        "CPFL-PAULISTA",
        "CPFL-Paulista",
        "CPFL-Piratininga",
        "CPFL-Santa Cruz Nova",
        "CRELUZ-D",
        "CRERAL",
        "DCELT",
        "DEMEI",
        "DMEPC",
        "EAC",
        "EDP ES",
        "EDP SP",
        "EFLJC",
        "EFLUL",
        "ELEKTRO",
        "ELETROCAR",
        "ELFSM",
        "EMR",
        "EMS",
        "EMT",
        "ENEL CE",
        "ENEL RJ",
        "ENEL SP",
        "ENEL SP",
        "EPB Nova",
        "Equatorial AL",
        "Equatorial GO",
        "Equatorial MA",
        "Equatorial PA",
        "Equatorial PI",
        "ERO",
        "ESE",
        "ESS",
        "ETO",
        "FORCEL",
        "HIDROPAN",
        "LIGHT",
        "MUX-Energia",
        "NDB",
        "RGE Nova",
        "RR Energia",
        "SULGIPE",
        "UHENPAL",
      ],
    };
  },
  methods: {
    retorna(){
      this.$router.back();     
    },
    async sendForm() {
      let error = "";

      if (this.emailError) {
        error = "Por favor, informe um e-mail válido";
      }

      if (this.form.cargo == "") {
        error = "Informe o cargo";
      }

      if (this.form.empresa == "") {
        error = "Informe a razão social";
      }

      if (this.form.email == "") {
        error = "Inserir o e-mail";
      }

      if (this.form.telefone == "") {
        error = "Informe o telefone";
      }
      if (this.form.nome == "") {
        error = "Informa o nome";
      }

      // if (this.form.custo == "" || this.form.custo <= 0) {
      //   error = "Informa o custo da energia";
      // }

      if (error != "") {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                       ${error}
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      // const camposObrigatorios = [
      //   "distribuidora_energia",
      //   "classe_tensao_atual",
      //   "modalidade",
      //   "desconto_tarifa",
      //   "consumo_fora_ponta_mwh_mes",
      //   "consumo_ponta_mwh_mes",
      //   "demanda_fora_ponta_kw"
      // ];

      // if (this.subestacao.modalidade === 'Azul') {
      //   camposObrigatorios.push("demanda_ponta_kw");
      // }

      // let possuiCamposInvalidos = this.subestacoes.some((subestacao) => {
      //   return camposObrigatorios.some((campo) => {
      //     const valor = subestacao[campo];

      //     return (
      //       valor === null || valor === undefined || String(valor).trim() === ""
      //     );
      //   });
      // });

      let possuiCamposInvalidos = this.subestacoes.some((item) => {
        // 1. Define os campos que são sempre obrigatórios
        const camposBase = [
          "distribuidora_energia",
          "classe_tensao_atual",
          "modalidade",
          "desconto_tarifa",
          "consumo_fora_ponta_mwh_mes",
          "consumo_ponta_mwh_mes",
          "demanda_fora_ponta_kw",
        ];

        // 2. Adiciona o campo extra APENAS se a modalidade deste item específico for 'Azul'
        const camposDoItem = item.modalidade === 'Azul' 
          ? [...camposBase, "demanda_ponta_kw"] 
          : camposBase;

        // 3. Valida os campos apenas para o item atual da iteração
        return camposDoItem.some((campo) => {
          const valor = item[campo];
          return valor === null || valor === undefined || String(valor).trim() === "";
        });
      });

      if (possuiCamposInvalidos) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Preencha todos os campos do formulário
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      this.salvaPlanilha();
    },
    async salvaPlanilha() {
      const formData = {
        form: this.form,
        equipamentos: this.subestacoes,
      };

      Swal.showLoading();
      let valores = JSON.stringify(formData);

      let res = await this.callLocalAction("save_estudo", {
        dados: valores,
      });

      if (res && res.ok && res.ok.ok) {
        Swal.fire({
          icon: "success",
          title:
            "<strong style='font-size: 20px !important;'>Resultado enviado</strong>",
          html: `
              <div style="padding: 10px;">
                  <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                    O resultado da simulação foi enviado para o e-mail informado: <b>${this.form.email}</b>
                  </p>
                </div>
            `,
          confirmButtonText: "Ok",
          confirmButtonColor: "#68b842",
        }).then(async () => {
          this.retorna();
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Erro ao salvar</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Não foi possível realizar o estudo
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }
    },
    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !regex.test(this.form.email);
    },
    validateRequired() {
      if (this.emailError) return "Por favor, informe um e-mail válido";
      if (!this.form.custo) return "Informe o custo da energia";
      if (!this.form.cargo) return "Informe o cargo";
      if (!this.form.empresa) return "Informe a razão social";
      if (!this.form.email) return "Informe o e-mail";
      if (!this.form.telefone) return "Informe o telefone";
      if (!this.form.nome) return "Informe o nome";

      const requiredFields = [
        "distribuidora_energia",
        "classe_tensao_atual",
        "modalidade",
        "desconto_tarifa",
        "consumo_fora_ponta_mwh_mes",
        "consumo_ponta_mwh_mes",
        "demanda_fora_ponta_kw",
        "demanda_ponta_kw",
      ];

      const hasInvalidData = this.subestacoes.some((subestacao) =>
        requiredFields.some((field) => !subestacao[field])
      );

      if (hasInvalidData) {
        return "Preencha todos os campos obrigatórios de subestação";
      }

      return "";
    },
    prepareForm() {
      const error = this.validateRequired();

      if (error) {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html:
            "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>" +
            error +
            "</p></div>",
          confirmButtonText: "Ok",
        });
        return;
      }

      this.payloadPreview = {
        tipo_simulador: "subestacao",
        form: { ...this.form },
        subestacoes: this.subestacoes.map((subestacao) => ({
          ...subestacao,
        })),
      };

      Swal.fire({
        icon: "success",
        title:
          "<strong style='font-size: 20px !important;'>Estrutura pronta</strong>",
        html: "<div style='padding: 10px;'><p style='font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;'>Os dados foram validados e o payload foi preparado localmente. Nenhuma informação foi salva no banco.</p></div>",
        confirmButtonText: "Ok",
        confirmButtonColor: "#68b842",
      });
    },
    addCard() {
      this.subestacoes.push(createSubestacao());
    },
    removeCard(index) {
      if (this.subestacoes.length === 1) return;
      this.subestacoes.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.card-custom {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: tint($body-color, 70%);
  border: 1px solid tint($brand-primary, 90%) !important;
  border-radius: 2.4rem !important;
  margin-bottom: -16px;

  .card-custom-text {
    padding: 16px !important;
  }
}

.simulator-card-title {
  display: flex;
  align-items: center;
}

.v-select__selection.v-select__selection--comma,
.v-input {
  font-size: 14px !important;
}

.v-text-field__details {
  display: none !important;
}

.primary {
  background-color: $brand-default !important;
  border-color: $brand-default !important;
}

.responsive-container {
  max-width: 1264px;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}
</style>
